import { FormControl, FormGroup, Validators } from '@angular/forms'

export function createForm(isRequestMaterial: boolean = false) {
  return new FormGroup({
    countries: new FormControl<string[]>([], { nonNullable: true, validators: isRequestMaterial ? [] : [Validators.required, Validators.minLength(1)] }),
    lastNameKana: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    firstNameKana: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    phoneNumber: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    email: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    agree: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    searchParameter: new FormControl<string | null>(null),
  });
}
